import { AbstractControl } from '@angular/forms';
import { isValidE164 } from '@app/shared/utils/phone.util';

export class PhoneValidators {
  /** Requires a complete E.164 number, the value `c-phone` outputs. */
  static phoneValid(control: AbstractControl): { [key: string]: any } | null {
    return isValidE164(control?.value) ? null : { validatePhoneNumber: true };
  }
}
